<template>

  <div class="container">
       <div class="page-header">
           <div class="page-title">
          
               <div class="crumbs">
                   <ul id="breadcrumbs" class="breadcrumb">
                       <li>
                         <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                       </li>
                       <li class="active">
                         <router-link :title="'الاشتعارات'" :to="{name: 'parentNotifications'}"> الاشعارات</router-link>
                       </li>
                   </ul>
               </div>
           </div>
       </div>
       
       <div class="row"> 
           <div class="col-lg-12 col-md-12 layout-spacing">
               <div class="statbox widget box box-shadow">
                   <div class="widget-header">
                       <div class="row">
                           <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                               <h4>
                                  البيانات 

                               </h4>
                           </div>          
                       </div>
                   </div>
                   <div class="widget-content widget-content-area">
                      
                       <div class="table-responsive">
                           <table class="table table-striped table-bordered">
                             <tbody>
                              

                               <tr>
                                 <th>
                                   ولى الامر
                                 </th>
                                 <td>
                                   {{ notification.user ? notification.user.name : '' }}
                                 </td>
                               </tr>



                               <tr>
                                 <th>
                                   العنوان
                                 </th>
                                 <td>
                                   {{ notification.title }}
                                 </td>
                               </tr>

                               <tr>
                                 <th>
                                    النص
                                 </th>
                                 <td>
                                   {{ notification.content }}
                                 </td>
                               </tr>            
                             </tbody>
                           </table>

                           <table class="table table-striped table-bordered">
                             <tbody>
                              <tr>
                                <th colspan="4">الردود</th>
                              </tr>
                              <tr>
                                <th>العنوان</th>
                                <th>النص</th>
                                <th>تاريخ الارسال</th>
                              </tr>
                               <tr v-for="(rep, k) in notification.replies" :key="k">
                                 <th>
                                   {{ rep.title }}
                                 </th>
                                 <td>
                                   {{ rep.content }}
                                 </td>
                                 <td>
                                  {{ rep.creation_date  }}
                                 </td>
                               </tr>
         
                             </tbody>
                           </table>
                       </div>
                      
                   </div>
               </div>
                
           </div>
          
       </div>
   </div>

</template>
<script>
import router from '@/router'

export default {
data() {
return {
notification: {},
isRequested: false,
msg: '',
msgSent: ''
};
},
created() {
this.findOne();
},
methods: {
findOne() {
this.$baseApi.get('/parentNotifications/' + this.$route.params.id).then((response) => {
if (response.data.code === 200 && response.data.data != null) {
 this.notification = response.data.data.parentNotification;
}
});
},
},
computed: {
trans() {
return this.$store.getters.GET_TRANS;
}
}
}

</script>
<style>
</style>
